import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { applicationPaths, localStorageKeys } from '../../../Models/configurations';
import { CommonLocalizationService } from '../../../Services/common-localization.service';
import { SecureStorageService } from './../../../Services/secure-storage.service';
import { UtilityServices } from './../../../Services/utility.services';
import { SecureStorage } from '../../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from '../../../../../../Widget/src/app/business-entities/step.class';
import * as CommonEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from '../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import * as signalR from '@microsoft/signalr';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { SignalRHubEventType } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckInDataService } from '../../../Services/check-in-data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.css']
})
export class MainHeaderComponent implements OnInit {
  urlText: string;
  public logoLink: string;
  isLanguageFlag:boolean=false;
  currentLang: string;
  languageModel: any[];
  selectedLanguageText: string;
  selectedLanguageFlag: string;
  selectedLangExpireDate = new Date();
  logoUrlLink: string;
  features: Features[] = [];
  EnableCookieConsent:boolean = false;
  isProd = false;

  constructor(
    private readonly utilityService: UtilityServices,
    private readonly secureStorageService: SecureStorageService,
    private readonly commonLocalizationService: CommonLocalizationService,
    private readonly cookieService: CookieService,
    private readonly translate: TranslateService,
    private readonly cdr: ChangeDetectorRef,
    private readonly globalSetting: GlobalSetting,
    private readonly secureStorage: SecureStorage,
    public spinner: NgxSpinnerService,
    private readonly currentLanguage:CurrentLanguage,
    private readonly modalService: NgbModal,
    private readonly checkInDataService: CheckInDataService,
    private readonly router: Router,
    private readonly zone: NgZone,
    private readonly currentLanguageService: CurrentLanguage
  ) {
    this.urlText = '/' + applicationPaths.login;
  }

  public backToHome(): void {
    if (!JSON.parse(this.secureStorageService.getKeyData(localStorageKeys.checkingModule).checkInStatus)) {
      this.utilityService.navigateToNext(this.urlText);
    }
  }

  ngOnInit(): void {
    this.isProd = environment.production;
    this.logoLink = this.secureStorageService.getKeyData(localStorageKeys.logo);
    this.logoUrlLink = this.globalSetting.getGlobalLogoUrlLink();
    this.selectedLangExpireDate.setDate(this.selectedLangExpireDate.getDate() + 1);
    this.GetFeature();
    this.currentLanguage.featureList.subscribe((response) => {
      if(response?.length > 0){
        this.EnableCookieConsent = response?.find(x => x.featureCode === CommonEnums.FeatureCode.EnableCookieConsent)?.isActive;
        if(this.EnableCookieConsent){
          let node = document.createElement('script'); 
          node.src = EnvSetting.CheckIn_CookieScript_Key; 
          node.type = 'text/javascript'; 
          document.getElementsByTagName('head')[0].appendChild(node);
         }
      }
    })
    if (EnvSetting.language.LanguageOverRule) {
      this.currentLang = EnvSetting.language.LanguageOverRuleDefault;
      this.cookieService.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false,"Strict");
    }
    else{
      this.isLanguageFlag = true;
      this.commonLocalizationService.getAllLanguages().subscribe(res => {
        this.languageModel = res;
        if (this.isCookiesExist()) {
          this.currentLang = this.cookieService.get('userSelectedLanguage');
          this.selectedLanguageText = this.languageModel.find(search => search.key === this.currentLang).value;
          this.selectedLanguageFlag = this.getFlagImage(this.languageModel.find(search => search.key === this.currentLang).flagName);
        } else {
          this.currentLang=  this.commonLocalizationService.customerDefaultLanguage ?? EnvSetting.CHECKIN_DEFAULT_LANGUAGE_CONFIG;
          this.selectedLanguageText = this.languageModel.find(search => search.key === this.currentLang).value;
          this.selectedLanguageFlag = this.getFlagImage(this.languageModel.find(search => search.key === this.currentLang).flagName);
        }
          this.cookieService.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false,"Strict");
          this.translate.use(this.currentLang);
      });
    }
    this.initNotificationConfig();
  }

  getFlagImage(flag: string) {
    let uri = "assets/images/countryflags/"
    return uri + flag;
  }
  private isCookiesExist(): boolean {
    return this.cookieService.check('userSelectedLanguage');
  }

  ChangeLanguage(languageCode: string) {
    this.cookieService.set('userSelectedLanguage', languageCode, this.selectedLangExpireDate, '/', '', false,"Strict");
    this.translate.use(languageCode);
    this.currentLang = languageCode;
    this.selectedLanguageText = this.languageModel.find(search => search.key === languageCode).value;
    this.selectedLanguageFlag = this.getFlagImage(this.languageModel.find(search => search.key === languageCode).flagName);
    this.currentLanguageService.currentLanguage.next(languageCode);
    this.cdr.detectChanges();
  }

  GetFeature(){
    this.secureStorage.removeKey('feature');
    this.spinner.show();
    this.commonLocalizationService.getFeatures().then((res)=>{
      if(res.responseObject.errorCount === 0){
        this.features = res.responseObject.result;
        if(this.features && this.features.length >0){
            this.secureStorage.setKeyData('feature', this.features);
            this.currentLanguage.featureList.next(this.features);
            if (this.secureStorage.getKeyData('feature')) {
              this.features = this.secureStorage.getKeyData('feature');
            }
        }
      }
    })
    this.spinner.hide();
  }

  //#region  Push Notification
  initNotificationConfig(){
    let details = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    const userId = `${details?.workOrderId}|${details?.customerDetail?.customerId}`;
    if (userId) {
      const connection = new signalR.HubConnectionBuilder()
        .configureLogging(signalR.LogLevel.Critical)
        .withUrl(`${EnvSetting.PUSH_NOTIFICATION_API_URI}PushNotification?userId=${userId}`)
        .withAutomaticReconnect()
        .build();

      connection.start().catch(function (err) {
        return console.log(err);
      }).then(function () {
        connection.invoke('GetConnectionId').then(function (_connectionId)
        {
          // This is intentional
        });
      });
      this.globalSetting.signalrConnection.next(connection);
      connection.on(SignalRHubEventType.DocumentUploaded, (data) => {
        this.DocumentUploaded(data,details?.appointmentGuid);
      });
      connection.on(SignalRHubEventType.AppointmentRemoved, (data) => {
        this.OnAppointmentRemoved(data);
      });
      connection.on(SignalRHubEventType.WarrantySigned, (data) => {
        this.OnWarrantyDocumentSigned(data);
      });
    }      
  }
  OnAppointmentRemoved(data){
 
    let details = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    if (details?.appointmentGuid == data?.appointmentId) {
      this.utilityService.pageNotFoundMessage = this.translate.instant("lblAppointmentNotFound");
      this.zone.run(() => {
        this.router.navigate(['/pagenotfound']);
      });
      let modelHeadermsg = this.translate.instant('lblAppointmentDeleted');
      let modelBodymsg = this.translate.instant('lblAppointmentDeletedMsg');
      const updatedModalRef = this.modalService.open(NgInfoModalContent, { backdrop: false, keyboard: false, centered: true });
      updatedModalRef.componentInstance.modelHeader = modelHeadermsg;
      updatedModalRef.componentInstance.modelBody = modelBodymsg;
      updatedModalRef.result.then((_result) => { 
        this.removeStorageKeys();
      }, (_reason) => {
        this.removeStorageKeys();
      });
    }
  }
  private removeStorageKeys(){
    this.secureStorageService.removeStringKeyArray([
      localStorageKeys.checkInParams,
      localStorageKeys.checkingModule,
      localStorageKeys.screenConfig,
      localStorageKeys.ownerDetails,
      localStorageKeys.privacyConsent,
      localStorageKeys.additionalDetails,
      localStorageKeys.servicePlanDetails,
      localStorageKeys.serviceDetails,
      localStorageKeys.offerValueDetails,
      localStorageKeys.notifyUserDetails,
      localStorageKeys.appointmentConfirm,
      localStorageKeys.clientName,
      localStorageKeys.stepStatus,
      localStorageKeys.logo,
      localStorageKeys.currencyType,
      localStorageKeys.unauthorizeUser,
      localStorageKeys.cdkRepairData,
      localStorageKeys.tinyUrl,
      localStorageKeys.nomineeContactDetails,
      localStorageKeys.isCheckInNotAllowed]);
  }
  DocumentUploaded(data,appointmentGuid){
    if (data.appointmentGuid == appointmentGuid) {
      this.checkInDataService.GetDocumentCount().then((res)=>{
        if (res?.responseObject?.length > 0) {
          this.checkInDataService.DemandWiseDocumentCountList = res.responseObject;
        }
      })
    }
  }
  OnWarrantyDocumentSigned(data){
    let details = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    if (details?.appointmentGuid == data?.appointmentId) {
      this.globalSetting.warrantyDocumentSigned.next(true);
    }
  }
  //#endregion
}
